import styled from 'styled-components';

interface Props {
  isDragActive?: any;
  dragActive?: any;
  dragReject?: any;
  isDragReject?: any;
}
interface Type {
  type?: 'default' | 'error' | 'success';
}

export const Container = styled.div`
  display: flex;
  div {
    width: 100%;
  }
`;
export const Page = styled.div`
  width: 100%;
`;
export const SubPage = styled.div`
  min-width: 95%;
  max-width: 95%;
  margin-left: auto;
  margin-right: auto;
`;
export const Title = styled.h3`
  top: 0;
  position: absolute;
  color: #fff;
  font-size: 22px;
  text-align: center;
  font-weight: bolder;
  background-color: #2b3040;
  width: 90%;
  padding: 20px;
`;
export const PaginateBar = styled.div``;

export const AddMall = styled.div`
  justify-content: center;
  align-items: center;

  background-color: #fff;
  padding: 1%;
  input {
    border-radius: 7px;
    border: 2px solid #f0f0f0;
    width: 77%;
    margin-left: 10%;
    height: 27px;
    padding-left: 30%;
    margin-bottom: 0;
  }
  div {
    display: flex;
    margin-left: 4px;
  }
  label {
    margin: 1%;
  }
  form {
    display: flex;
    width: 100%;
    div {
      display: block;
      input {
        border-radius: 7px;
        border: 2px solid #f0f0f0;
        padding-left: 10%;
        width: 100%;
        margin-left: 0%;
      }
    }
  }
  button {
    margin-left: 40%;
  }
`;

export const MapStyle = styled.div`
  
`;

export const ListUsers = styled.div`
  margin-top: 3%;
  background-color: #f3f3f7;
`;
export const RepositoriesInfo = styled.div`
  width: 100%;
  padding: 2%;
  table {
    width: 100%;
    thead {
      tr {
        th {
          color: #f3f3f7;
          font-family: 'Roboto', sans-serif;
          font-size: 12px;
          & + th {
            background-color: #fff;
            border: 1px solid #f0f0f0;
            color: #151715;
            font-family: 'Roboto', sans-serif;
            font-size: 12px;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          padding-left: 8px;
          padding-right: 1px;
          margin-right: 0px;
          height: 100%;
          max-width: 5px;
          background-color: #f3f3f7;
          button {
            margin-left: 27%;
            border: none;
            background-color: #fff;
            & + button {
              margin-left: 5%;
            }
          }
          & + td {
            padding: 1px;
            height: 32px;
            margin: 0;
            max-width: none;
            padding: 1px;
            background-color: #fff;
            border: 1px solid #f0f0f0;
            font-size: 12px;
          }
        }
      }
    }
  }
`;

export const Logo = styled.img`
  max-width: 45%;
  margin-left: 7px;
  height: 2%;
  border-radius: 50%;
`;
export const BtnNewCat = styled.div`
  padding: 20px;
  background-color: #27e51a;
  max-width: 200px;
  min-width: 200px;
  display: flex;
  border-radius: 7px;
  color: #fff;
  align-items: center;
  justify-content: center;
`;

export const LabelText = styled.h2`
  font-size: 17px;
  color: #000;
  margin: 20px;
`;
export const CategoryText = styled.h2`
  font-size: 14px;
  color: #000;
  width: 77%;
  margin-left: auto;
  margin-right: auto;
`;
export const InputText = styled.input`
  max-width: 100%;
  border: none;
  min-width: 100%;
  min-height: 30px;
  max-height: 30px;
`;
export const InputContainer = styled.div`
  max-width: 400px;
  min-width: 400px;
  max-height: 50px;
  min-height: 50px;
  padding: 7px;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: none;
  border-radius: 12px;
  margin: 40px;
`;
export const InputContainerSearch = styled.div`
  max-width: 400px;
  min-width: 400px;
  max-height: 50px;
  min-height: 50px;
  padding: 7px;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: none;
  border-radius: 12px;
  margin: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const InputContainerNumber = styled.div`
  max-width: 100px;
  min-width: 100px;
  max-height: 50px;
  min-height: 50px;
  padding: 7px;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: none;
  border-radius: 12px;
  margin: 40px;
`;

export const BtnCreateCategory = styled.button`
  padding: 12px;
  background-color: #1B7D84;
  margin: 17px;
  max-width: 200px;
  min-width: 200px;
  display: flex;
  border-radius: 22px;
  color: #fff;
  align-items: center;
  justify-content: center;
`;
export const BtnBack = styled.button`
  padding: 12px;
  background-color: transparent;
  max-width: 100px;
  min-width: 100px;
  display: flex;
  border-radius: 22px;
  color: #000;
  align-items: center;
  justify-content: center;
`;

export const DivRowFlex = styled.div`
  background-color: transparent;
  max-width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
`;
